import { render } from "./realname.vue?vue&type=template&id=28da7396&scoped=true&ts=true"
import script from "./realname.vue?vue&type=script&setup=true&lang=ts"
export * from "./realname.vue?vue&type=script&setup=true&lang=ts"

import "./realname.vue?vue&type=style&index=0&id=28da7396&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28da7396"],['__file',"src/views/me/realname.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28da7396"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28da7396', __exports__)) {
    console.log('reload')
    api.reload('28da7396', __exports__)
  }
  
  module.hot.accept("./realname.vue?vue&type=template&id=28da7396&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('28da7396', render)
  })

}


export default __exports__